/**
 * Booking Trigger Frontend Script
 */
import { createRoot, useState, useEffect } from '@wordpress/element';
import BookingModal from '../components/BookingModal';

document.addEventListener('DOMContentLoaded', () => {
    // Check if we have any triggers
    const triggers = document.querySelectorAll('.nemtly-booking-trigger-btn');
    if (triggers.length === 0) {
        return;
    }

    // Create a container for the modal manager if it doesn't exist
    let modalContainer = document.getElementById('nemtly-booking-modal-manager');
    if (!modalContainer) {
        modalContainer = document.createElement('div');
        modalContainer.id = 'nemtly-booking-modal-manager';
        document.body.appendChild(modalContainer);
    }

    // Modal Manager Component
    const ModalManager = () => {
        const [isOpen, setIsOpen] = useState(false);
        const [currentEvent, setCurrentEvent] = useState(null);

        useEffect(() => {
            const handleTriggerClick = (e) => {
                const btn = e.target.closest('.nemtly-booking-trigger-btn');
                if (btn) {
                    e.preventDefault();
                    const eventId = btn.getAttribute('data-event-id');
                    // We might need to fetch title or pass it via data attribute
                    const eventTitle = btn.getAttribute('data-event-title') || '';

                    if (eventId) {
                        setCurrentEvent({ id: parseInt(eventId, 10), title: eventTitle });
                        setIsOpen(true);
                    }
                }
            };

            document.addEventListener('click', handleTriggerClick);
            return () => document.removeEventListener('click', handleTriggerClick);
        }, []);

        return (
            <BookingModal
                isOpen={isOpen}
                onClose={() => setIsOpen(false)}
                event={currentEvent}
            />
        );
    };

    const root = createRoot(modalContainer);
    root.render(<ModalManager />);
});
